import { LOCALE_ID, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { EMPTY, firstValueFrom } from 'rxjs';

import { PageScope, UIPage, defaultVideoCategorizer } from 'shared-lib/core';
import { MetaService, ScopeService } from '@core/services';

const LABELS = {
  TITLE: $localize`:@@calendarPageTitle:Calendar`,
} as const;

export const resolveCalendarPage: ResolveFn<
  PageScope
> = async (): Promise<PageScope> => {
  const locale = inject(LOCALE_ID);
  const metaService = inject(MetaService);
  const scopeService = inject(ScopeService);

  const channel = await firstValueFrom(scopeService.listenToChannel());

  metaService.setTags({
    description: '',
    image: channel.branding.logoImage,
    title: LABELS.TITLE,
  });

  const activePage: UIPage = {
    name: 'Calendar',
    active: true,
    status: 'PUBLISHED',
    header: {
      text: LABELS.TITLE,
      subText: '',
      bannerImages: 'INHERIT',
      type: 'TAG' as const,
    },
    modules: [
      {
        moduleType: 'FILTERED_VIDEOS_LIST',
        filters: 'DEFAULT',
        size: 20,
        density: 'NORMAL',
        layoutType: 'CATEGORIZED_GRID',
        listSource: { paged: true },
        sort: 'DATE',
        order: 'ASC',
        categorizer: defaultVideoCategorizer(locale),
      },
    ],
  };
  return {
    activePage,
    userHasAccess$: EMPTY,
  };
};
